import React, { useEffect } from "react";
import { useState } from "react";
import Button from "@material-ui/core/Button";
import { CustomInput } from "../common/SimpleInput";
import { useDispatch, useSelector } from "react-redux";
import { getUserData, postLogin } from "../../redux/authentication/thunks";
import logoBosch from "../../images/BoschLogo_Large.svg";
import { unwrapResult } from "@reduxjs/toolkit";
import { useHistory } from "react-router";
import { ROUTE_PANEL } from "../routes/routesConstants";
import { openModal } from "../../redux/modal/modalSlice";
import { selectUserLoading } from "../../redux/authentication/selectors";
import { errorHandler } from "../../commonFunctions/errorHandler";
import { parseJwtToken } from "../../commonFunctions/commonFunctions";
import { useTranslation } from "react-i18next";

function Login(props) {
  const { t } = useTranslation();
  const [user, setUser] = useState({ username: "", password: "" });
  const [error, setError] = useState({
    username: undefined,
    password: undefined,
  });
  const dispatch = useDispatch();
  const history = useHistory();
  //const loading = useSelector(selectUserLoading);
  const [loading, setLoading] = useState(false)

  function handleUser(value, field) {
    setError({ ...error, [field]: undefined });
    setUser({ ...user, [field]: value });
  }

  useEffect(() => {
    let token = localStorage.getItem("apoloCRM_Token");
    if (token) {
      redirectToHomePage();
    }
  }, []);

  async function handleSubmit(e) {   
    e.preventDefault();
    setLoading(true);

    if (!validateForm()) {
      return;
    }

    try {
      const resultAction = await dispatch(postLogin(user));
      const loginData = unwrapResult(resultAction);
      localStorage.setItem("apoloCRM_Token", loginData.token);
      const token = parseJwtToken();
      const userData = await dispatch(getUserData({ param: token.sub }));
      redirectToHomePage();
    } catch (err) {
      if (err.message === "USER_NOT_FOUND") {
        setError({ ...error, username: t("UserNotFound") });
      } else if (err.message === "INVALID_PASSWORD") {
        setError({ ...error, password: t("InvalidCredentials") });
      } else {
        dispatch(openModal(errorHandler(err)));
      }
      setLoading(false);
    }
  }

  function redirectToHomePage() {
    let redirectionUrl;
    if (props.location.state) {
      redirectionUrl = props.location.state.from + props.location.state.search;
    }
    history.push(redirectionUrl || ROUTE_PANEL);
  }

  function validateForm() {
    let valid = true;
    if (user.username === "") {
      setError((prevState) => ({
        ...prevState,
        username: t("RequiredField"),
      }));
      valid = false;
    }
    if (user.password === "") {
      setError((prevState) => ({
        ...prevState,
        password: t("RequiredField"),
      }));
      valid = false;
    }
    return valid;
  }

  return (
    <div className="login-section">
      <form onSubmit={handleSubmit} className="login-box">
        <div style={{display: "flex", margin: "-25px 0 15px"}}>
          <img src={logoBosch}  style={{height: "7rem", width:"40%"}} />
        </div>
        {/* <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
            <img src={logoBosch}  style={{height: "7rem", width:"40%"}} />
            <div>
                <span style={{fontSize: "5rem", fontWeight: 100, width:"20%"}}>|</span>
            </div>
            <img src={logoElectrolux} style={{height: "3rem", width:"40%"}}></img>
        </div> */}
        <CustomInput
          type="text"
          label={t("Username")}
          value={user.username}
          onChange={(e) => handleUser(e, "username")}
          error={error.username ? true : false}
          error_text={error.username}
        />
        <CustomInput
          type="password"
          label={t("Password")}
          value={user.password}
          onChange={(e) => handleUser(e, "password")}
          error={error.password ? true : false}
          error_text={error.password}
        />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          //disabled={loading === "loading" ? true : false}
          disabled={loading}
        >
          {t("Enter")}
        </Button>
      </form>
    </div>
  );
}

export { Login };
